const CENTS = 100;

export const calculateTotal = (arr) => (arr.length ? arr.reduce((accumulator, item) => accumulator + Number(item.price), 0) : 0);

export function convertPriceText(price) {
    if (price) return `+$${price}`;
    else if (price == 0) return "Free";
    else return "Included";
}

export function parsePrice(price, fixed = 2) {
    const totalPrice = price / CENTS;

    return totalPrice.toFixed(fixed);
}
